import { DynamicPageUrlValidationError } from '@wix/wix-data-client-types'

const dynamicPageUrlValidationErrorV1: { [key: string]: string } = {
  [DynamicPageUrlValidationError.URL_TOO_LONG]:
    'Dynamic_Pages_Validations_URL_Too_Long',
  [DynamicPageUrlValidationError.PREFIX_STARTS_WITH_TEXT]:
    'DYNAMIC_PAGES_VALIDATIONS_PREFIX_STARTS_WITH_TEXT',
  [DynamicPageUrlValidationError.NO_FIELD_IN_PREFIX]:
    'Dynamic_Pages_Validations_No_Field_In_Prefix',
  [DynamicPageUrlValidationError.NO_SPECIAL_CHARS]:
    'Dynamic_Pages_Validations_No_Special_Chars',
  [DynamicPageUrlValidationError.NO_DELETED_FIELD]:
    'Dynamic_Pages_Validations_No_Deleted_Fields',
  [DynamicPageUrlValidationError.ONLY_EXISTING_FIELDS]:
    'Dynamic_Pages_Validations_Only_Existing_Fields',
  [DynamicPageUrlValidationError.PATTERN_ALREADY_EXISTS]:
    'Dynamic_Pages_Validations_Pattern_Already_Exists',
  [DynamicPageUrlValidationError.SEPARATE_FIELDS]:
    'Dynamic_Pages_Validations_Separate_Dynamic_Fields',
  [DynamicPageUrlValidationError.UNSUPPORTED_FIELDS]:
    'Dynamic_Pages_Pages_Info_Error_URL_Unsupported_Field',
  [DynamicPageUrlValidationError.URL_EMPTY]:
    'DYNAMIC_PAGES_ITEM_SETUP_SCREEN_ERROR',
}

const dynamicPageUrlValidationErrorV2: { [key: string]: string } = {
  [DynamicPageUrlValidationError.URL_TOO_LONG]:
    'Dynamic_Pages_Validations_URL_Too_Long',
  [DynamicPageUrlValidationError.PREFIX_STARTS_WITH_TEXT]:
    'DYNAMIC_PAGES_VALIDATIONS_PREFIX_STARTS_WITH_TEXT',
  [DynamicPageUrlValidationError.NO_FIELD_IN_PREFIX]:
    'Dynamic_Pages_Validations_No_Field_In_Prefix',
  [DynamicPageUrlValidationError.NO_SPECIAL_CHARS]:
    'Dynamic_Pages_Validations_No_Special_Chars_V2',
  [DynamicPageUrlValidationError.NO_DELETED_FIELD]:
    'Dynamic_Pages_Validations_No_Deleted_Fields',
  [DynamicPageUrlValidationError.ONLY_EXISTING_FIELDS]:
    'Dynamic_Pages_Validations_Only_Existing_Fields',
  [DynamicPageUrlValidationError.PATTERN_ALREADY_EXISTS]:
    'Dynamic_Pages_Validations_Pattern_Already_Exists_V2',
  [DynamicPageUrlValidationError.SEPARATE_FIELDS]:
    'Dynamic_Pages_Validations_Separate_Dynamic_Fields',
  [DynamicPageUrlValidationError.UNSUPPORTED_FIELDS]:
    'Dynamic_Pages_Pages_Info_Error_URL_Unsupported_Field',
  [DynamicPageUrlValidationError.URL_EMPTY]:
    'Dynamic_Pages_Validations_Url_Empty',
  [DynamicPageUrlValidationError.NO_VARIABLE]:
    'Dynamic_Pages_Validations_No_Variable',
  [DynamicPageUrlValidationError.EXACT_PATTERN_EXISTS]:
    'Dynamic_Pages_Validations_Exact_Pattern_Exists',
}

export function getDynamicPageUrlValidationErrorKey(
  error: DynamicPageUrlValidationError | string,
  useV2ErrorMapping?: boolean,
): string {
  const errorMapping = useV2ErrorMapping
    ? dynamicPageUrlValidationErrorV2
    : dynamicPageUrlValidationErrorV1
  return errorMapping[error] || error
}
